export const types = {
  Compound: 'Compound',
  Identifier: 'Identifier',
  MemberExpression: 'MemberExpression',
  Literal: 'Literal',
  ThisExpression: 'ThisExpression',
  CallExpression: 'CallExpression',
  UnaryExpression: 'UnaryExpression',
  BinaryExpression: 'BinaryExpression',
  SequenceExpression: 'SequenceExpression',
} as const

export type ExpressionType = (typeof types)[keyof typeof types]
